<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><i>For the Sybil… who speaks truth unadorned.</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?5dfd66fe